const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

class ZoomAnnouncement extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.items = [...this.querySelectorAll('[data-message]')];
    this.index = 0;
    this.delay = Number(this.dataset.speed || 5) * 1000;
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.show(0);
    this.start();
  }
  disconnectedCallback() { this.stop(); }
  show(index) {
    if (!this.items.length) return;
    this.index = (index + this.items.length) % this.items.length;
    this.items.forEach((item, i) => item.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
  }
  go(delta) { this.show(this.index + delta); this.start(true); }
  start(reset = false) {
    if (reset) this.stop();
    if (reducedMotion || this.items.length < 2 || this.timer) return;
    this.timer = setInterval(() => this.show(this.index + 1), this.delay);
  }
  stop() { clearInterval(this.timer); this.timer = null; }
}

class ZoomHeroSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.track = this.querySelector('[data-track]');
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.index = 0;
    this.delay = Number(this.dataset.speed || 6) * 1000;
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i)));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    let startX = 0;
    this.addEventListener('pointerdown', e => { startX = e.clientX; });
    this.addEventListener('pointerup', e => {
      const delta = e.clientX - startX;
      if (Math.abs(delta) > 50) this.go(delta > 0 ? -1 : 1);
    });
    this.show(0);
    this.start();
  }
  disconnectedCallback() { this.stop(); }
  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.track.style.transform = `translateX(${-this.index * 100}%)`;
    this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
  }
  go(delta) { this.show(this.index + delta); this.start(true); }
  start(reset = false) {
    if (reset) this.stop();
    if (reducedMotion || this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.timer) return;
    this.timer = setInterval(() => this.show(this.index + 1), this.delay);
  }
  stop() { clearInterval(this.timer); this.timer = null; }
}

class ZoomProductTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const buttons = [...this.querySelectorAll('[role="tab"]')];
    const panels = [...this.querySelectorAll('[role="tabpanel"]')];
    buttons.forEach((button, i) => button.addEventListener('click', () => {
      buttons.forEach((b, j) => b.setAttribute('aria-selected', i === j ? 'true' : 'false'));
      panels.forEach((panel, j) => panel.hidden = i !== j);
    }));
    this.querySelectorAll('[data-scroll-shell]').forEach(shell => {
      const scroller = shell.querySelector('[data-scroller]');
      shell.querySelector('[data-scroll-prev]')?.addEventListener('click', () => this.scroll(scroller, -1));
      shell.querySelector('[data-scroll-next]')?.addEventListener('click', () => this.scroll(scroller, 1));
    });
  }
  scroll(scroller, delta) {
    if (!scroller) return;
    const dir = document.documentElement.dir === 'rtl' ? -1 : 1;
    scroller.scrollBy({ left: dir * delta * Math.max(scroller.clientWidth * .82, 260), behavior: reducedMotion ? 'auto' : 'smooth' });
  }
}

class ZoomScrollRail extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const scroller = this.querySelector('[data-scroller]');
    const move = delta => {
      const dir = document.documentElement.dir === 'rtl' ? -1 : 1;
      scroller?.scrollBy({ left: dir * delta * Math.max(scroller.clientWidth * .82, 280), behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    this.querySelector('[data-scroll-prev]')?.addEventListener('click', () => move(-1));
    this.querySelector('[data-scroll-next]')?.addEventListener('click', () => move(1));
  }
}

if (!customElements.get('zoom-announcement')) customElements.define('zoom-announcement', ZoomAnnouncement);
if (!customElements.get('zoom-hero-slider')) customElements.define('zoom-hero-slider', ZoomHeroSlider);
if (!customElements.get('zoom-product-tabs')) customElements.define('zoom-product-tabs', ZoomProductTabs);
if (!customElements.get('zoom-scroll-rail')) customElements.define('zoom-scroll-rail', ZoomScrollRail);
